"use client";

import { useEffect, useSyncExternalStore } from "react";

const BODY_CLASS = "mobile-nav-open";

let mobileNavOpen = false;
const listeners = new Set<() => void>();

function emit() {
    listeners.forEach((listener) => listener());
}

/** Set from MobileNavMenu when the full-screen drawer opens/closes. */
export function setMobileNavOpen(open: boolean) {
    if (mobileNavOpen === open) return;
    mobileNavOpen = open;
    emit();
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

function getSnapshot() {
    return mobileNavOpen;
}

function getServerSnapshot() {
    return false;
}

/** Subscribe to mobile nav open state (e.g. hide sticky CTA under the drawer). */
export function useMobileNavOpen() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Toggle a body class for CSS hooks while the mobile nav is open. */
export function useSyncMobileNavBodyClass(open: boolean) {
    useEffect(() => {
        document.body.classList.toggle(BODY_CLASS, open);
        return () => {
            document.body.classList.remove(BODY_CLASS);
        };
    }, [open]);
}
